import hasTranslationContent from "utils/hasTranslationContent";

// getTranslationInitialValues creates a translation for every locale of the organization,
// this removes the ones the user left empty so that we do not persist blank translations
export default function removeEmptyTranslations(translations) {
    if (!translations || Array.isArray(translations)) {
        return translations;
    }

    return Object.fromEntries(
        Object.entries(translations).filter(([, translation]) =>
            // an already persisted translation is kept, emptying it is not our business here
            translation?.['@id'] || hasTranslationContent(translation)
        )
    );
}
